module.exports = __webpack_public_path__ + "img/bg_5.0be06db5.jpg";